/* Pinnie: lightbox voor productfoto's op desktop (>= 990px).
   Onderschept de klik op een productfoto voordat Dawn's eigen modal/zoom reageert. */
(function () {
  var DESKTOP = window.matchMedia('(min-width: 990px)');
  var box, imgEl, counterEl, prevBtn, nextBtn, lastFocus;
  var items = [];
  var index = 0;

  function build() {
    if (box) return;
    box = document.createElement('div');
    box.className = 'pinnie-lightbox';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', 'Productfoto vergroot');
    box.innerHTML =
      '<button type="button" class="pinnie-lightbox__btn pinnie-lightbox__close" aria-label="Sluiten"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
      '<button type="button" class="pinnie-lightbox__btn pinnie-lightbox__prev" aria-label="Vorige foto"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg></button>' +
      '<img class="pinnie-lightbox__img" alt="">' +
      '<button type="button" class="pinnie-lightbox__btn pinnie-lightbox__next" aria-label="Volgende foto"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg></button>' +
      '<div class="pinnie-lightbox__counter" aria-live="polite"></div>';
    document.body.appendChild(box);

    imgEl = box.querySelector('.pinnie-lightbox__img');
    counterEl = box.querySelector('.pinnie-lightbox__counter');
    prevBtn = box.querySelector('.pinnie-lightbox__prev');
    nextBtn = box.querySelector('.pinnie-lightbox__next');

    box.querySelector('.pinnie-lightbox__close').addEventListener('click', close);
    prevBtn.addEventListener('click', function (e) { e.stopPropagation(); show(index - 1); });
    nextBtn.addEventListener('click', function (e) { e.stopPropagation(); show(index + 1); });
    imgEl.addEventListener('click', function (e) { e.stopPropagation(); show(index + 1); });
    box.addEventListener('click', function (e) { if (e.target === box) close(); });

    document.addEventListener('keydown', function (e) {
      if (!box.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowRight') show(index + 1);
      else if (e.key === 'ArrowLeft') show(index - 1);
    });
  }

  function largestSrc(img) {
    if (img.srcset) {
      var best = null;
      img.srcset.split(',').forEach(function (c) {
        var parts = c.trim().split(/\s+/);
        var w = parseInt(parts[1], 10) || 0;
        if (!best || w > best.w) best = { u: parts[0], w: w };
      });
      if (best) return best.u;
    }
    return img.currentSrc || img.src;
  }

  function collect(gallery) {
    var list = [];
    gallery.querySelectorAll('.product__media-item').forEach(function (li) {
      if (getComputedStyle(li).display === 'none') return;
      var img = li.querySelector('.product__modal-opener--image img');
      if (!img) return;
      list.push({ el: li, src: largestSrc(img), alt: img.alt || '' });
    });
    return list;
  }

  function show(i) {
    if (!items.length) return;
    index = (i + items.length) % items.length;
    var item = items[index];
    imgEl.classList.remove('is-visible');
    var pre = new Image();
    pre.onload = function () {
      imgEl.src = item.src;
      imgEl.alt = item.alt;
      requestAnimationFrame(function () { imgEl.classList.add('is-visible'); });
    };
    pre.src = item.src;
    counterEl.textContent = (index + 1) + ' / ' + items.length;
    var single = items.length < 2;
    prevBtn.hidden = single;
    nextBtn.hidden = single;
    counterEl.hidden = single;
  }

  function open(gallery, li) {
    build();
    items = collect(gallery);
    if (!items.length) return;
    var start = 0;
    items.forEach(function (it, n) { if (it.el === li) start = n; });
    lastFocus = document.activeElement;
    box.classList.add('is-open');
    document.body.classList.add('pinnie-lightbox-open');
    show(start);
    box.querySelector('.pinnie-lightbox__close').focus();
  }

  function close() {
    if (!box) return;
    box.classList.remove('is-open');
    document.body.classList.remove('pinnie-lightbox-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* Capture-fase: wij zijn eerder dan Dawn's modal-opener en magnify.js */
  document.addEventListener('click', function (e) {
    if (!DESKTOP.matches) return;
    var opener = e.target.closest && e.target.closest('.product__media-list .product__modal-opener--image');
    if (!opener) return;
    var gallery = opener.closest('media-gallery');
    if (!gallery) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    open(gallery, opener.closest('.product__media-item'));
  }, true);
})();
